"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APIcon = _interopRequireDefault(require("../APIcon"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./Pagination.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PaginationComponent = /*#__PURE__*/function (_Component) {
  function PaginationComponent() {
    var _this;
    _classCallCheck(this, PaginationComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PaginationComponent, [].concat(args));
    _defineProperty(_this, "getClasses", function () {
      return (0, _cssClassesHelper.getBEMClasses)(['pagination', "".concat(_this.props.customClass, "-pagination")]);
    });
    _defineProperty(_this, "goToPage", function (event, page) {
      event.preventDefault();
      _this.props.setActivePage && _this.props.setActivePage(page);
    });
    _defineProperty(_this, "goToNextPage", function (e, page) {
      _this.goToPage(e, page);
      _this.props.onRequestNext();
    });
    _defineProperty(_this, "goToPrevPage", function (e, page) {
      _this.goToPage(e, page);
      _this.props.onRequestPrev();
    });
    _defineProperty(_this, "renderNextButtons", function (page) {
      var t = _this.props.t;
      var _this$props = _this.props,
        nextPageEnabled = _this$props.nextPageEnabled,
        totalPages = _this$props.totalPages;
      var paginationClasses = _this.getClasses();
      var disabled = nextPageEnabled !== undefined ? !nextPageEnabled : totalPages === 0;
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: paginationClasses('next')
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: paginationClasses('text', {
          disabled: disabled
        }),
        onClick: function onClick(e) {
          return !disabled && _this.goToNextPage(e, page + 1);
        }
      }, t("Next"), /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "caretNext",
        customClass: paginationClasses('arrow', 'next')
      })));
    });
    _defineProperty(_this, "renderPreviousButtons", function (page) {
      var t = _this.props.t;
      var paginationClasses = _this.getClasses();
      var disabled = page === 0;
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: paginationClasses('previous')
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: paginationClasses('text', {
          disabled: disabled
        }),
        onClick: function onClick(e) {
          return !disabled && _this.goToPrevPage(e, page - 1);
        }
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "caretPrevious",
        customClass: paginationClasses('arrow', 'previous')
      }), t("Prev")));
    });
    return _this;
  }
  _inherits(PaginationComponent, _Component);
  return _createClass(PaginationComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
        content = _this$props2.content,
        activePage = _this$props2.activePage,
        setActivePage = _this$props2.setActivePage;
      var currentContent = content(activePage);
      if (activePage > 0 && currentContent.length === 0) {
        setActivePage(activePage - 1);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var paginationClasses = this.getClasses();
      var activePage = this.props.activePage;
      var content = this.props.content(activePage);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.containerClassName
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: paginationClasses('content')
      }, content), /*#__PURE__*/_react["default"].createElement("div", {
        className: paginationClasses('container')
      }, this.renderPreviousButtons(activePage), /*#__PURE__*/_react["default"].createElement("div", {
        className: paginationClasses('pages')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: paginationClasses('page')
      }, activePage + 1)), this.renderNextButtons(activePage)));
    }
  }]);
}(_react.Component);
_defineProperty(PaginationComponent, "propTypes", {
  totalPages: _propTypes["default"].number.isRequired,
  content: _propTypes["default"].func.isRequired,
  activePage: _propTypes["default"].number,
  containerClassName: _propTypes["default"].string,
  componentName: _propTypes["default"].string,
  customClass: _propTypes["default"].string
});
_defineProperty(PaginationComponent, "defaultProps", {
  activePage: 0,
  containerClassName: '',
  customClass: ''
});
var _default = exports["default"] = (0, _reactI18next.withTranslation)("core")(PaginationComponent);